import { apiClient } from '@/services/api';

export interface SportsResponse {
  sports: string[];
  other: string;
}

/**
 * Bundled fallback used only on first-launch when the backend is unreachable.
 * Must stay in sync with `SportsCatalog::SPORTS` in the Rails repo. The
 * server response is authoritative whenever it succeeds.
 */
export const FALLBACK_SPORTS: readonly string[] = [
  'Baseball',
  'Basketball',
  'Beach Volleyball',
  'Bowling',
  'Cheer',
  'Cross Country',
  'Dance',
  'Equestrian',
  'Fencing',
  'Field Hockey',
  'Football',
  'Golf',
  'Gymnastics',
  'Ice Hockey',
  'Lacrosse',
  'Rowing',
  'Skiing',
  'Soccer',
  'Softball',
  'Swimming & Diving',
  'Tennis',
  'Track & Field',
  'Volleyball',
  'Water Polo',
  'Wrestling',
  'eSports',
] as const;

export const FALLBACK_OTHER = 'Other / Not an athlete';

export const sportsService = {
  fetch(): Promise<SportsResponse> {
    return apiClient.get<SportsResponse>('/api/v1/sports', { skipAuth: true });
  },
};
